/*
 * fax-directory (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { faxDirectory } from "./fax-directory.schema"

/* Select */
export type FaxDirectory = z.infer<typeof selectFaxDirectorySchema>
export const selectFaxDirectorySchema = createSelectSchema(faxDirectory)

/* Filters */
export type FaxDirectoryFilters = z.infer<typeof faxDirectoryFiltersSchema>
export const faxDirectoryFiltersSchema = z.object({
	id: z.string().optional(),
	name: z.string().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createFaxDirectorySchema = createInsertSchema(faxDirectory, {
	name: z.string().min(1, "Name is required"),
	faxNumber: z.string().min(1, "Fax number is required"),
}).partial(globalCreateExclude)
export type CreateFaxDirectory = z.infer<typeof createFaxDirectorySchema>

/* Update */
export const updateFaxDirectorySchema = createInsertSchema(faxDirectory)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateFaxDirectory = z.infer<typeof updateFaxDirectorySchema>
